// extracted by mini-css-extract-plugin
export default {"container":"subscriptions_container__NJDYM","subscriptionServices":"subscriptions_subscriptionServices__2a7xc"};